export default "__VITE_ASSET__77ScK2z8__"